export default __webpack_public_path__ + "static/media/SLIDE_CONCRECAM_3.0f28e786.jpg";